import { DateTime } from "luxon";
import { Nullable } from "sonobello.utilities.react";

import { ICalendarService } from "../../../Calendar/Types/ICalendar";
import OpsAppointment, { IOpsAppointmentRequest } from "./OpsAppointment";

/** An appointment request for the OPS booking process. */
export interface IOpsAppointmentWithDistanceRequest extends IOpsAppointmentRequest {
  /** The distance in miles from the patient to the center. */
  distanceToCenterInMiles: Nullable<number>;
}

/** {@inheritdoc IOpsAppointmentWithDistanceRequest} */
class OpsAppointmentWithDistance extends OpsAppointment implements IOpsAppointmentWithDistanceRequest {
  readonly distanceToCenterInMiles: Nullable<number>;

  constructor(
    centerId: string,
    patientId: string,
    leadId: string,
    service: ICalendarService,
    startTimeUtc: DateTime,
    endTimeUtc: DateTime,
    note: string,
    slotId: number,
    distanceToCenterInMiles: Nullable<number>
  ) {
    super(centerId, patientId, leadId, service, startTimeUtc, endTimeUtc, note, slotId);
    this.distanceToCenterInMiles = distanceToCenterInMiles;
  }
}

export default OpsAppointmentWithDistance;
